<template>
	<div class="purchase-success-container" @click="onDismiss">
		<div class="alert-container">
			<img src="@/assets/alertsuccess.png" class="logo" />
			<!-- <span class="title">Your request has been sent successfully!</span> -->
			<span class="title">Copy and share this link to your friend for group sign in.</span>
			<!-- <span
        class="url-share mt10 normal-button"
        v-clipboard:copy="urlGroup"
        v-clipboard:success="onCopyClick"
			>{{urlGroup}}</span>-->
			<span
				class="home-button normal-button"
				v-clipboard:copy="urlGroup"
				v-clipboard:success="onCopyClick"
			>Copy link</span>
		</div>
	</div>
</template>
<script>
export default {
	name: "PurchaseGroupSuccess",
	props: {
		urlGroup: {
			type: String,
			isRequired: true,
		},
	},
	methods: {
		onDismiss() {
			this.$emit("onDismiss");
		},
		onCopyClick() {
			this.$emit("onCopyClick");
		},
	},
};
</script>
<style lang="scss" scoped>
.purchase-success-container {
	position: fixed;
	top: 0;
	bottom: 0;
	left: 0;
	right: 0;
	z-index: 100;
	background-color: rgba($color: #000000, $alpha: 0.5);
	display: flex;
	align-items: center;
	justify-content: center;
	.alert-container {
		display: flex;
		flex-direction: column;
		background-color: white;
		align-items: center;
		padding: 40px 15px 20px 15px;
		border-radius: 5px;
		margin: 0 10px;
		box-shadow: 0 10px 20px rgba($color: #000000, $alpha: 0.1);
		text-align: center;
		.logo {
			width: 80px;
			height: 80px;
		}
		.title {
			font-weight: 700;
			font-size: 20px;
			letter-spacing: 2px;
			margin-top: 30px;
		}
		.url-share {
			line-break: anywhere;
			font-style: italic;
		}
		.mt10 {
			margin-top: 20px;
		}
		.message {
			font-weight: 600;
			font-size: 16px;
			padding: 0 35px;
			margin-top: 25px;
		}
		.info-container {
			display: flex;
			flex-direction: column;
		}
		.info-message {
			font-weight: bold;
			font-size: 16px;
			padding: 0 35px;
		}
		.bottom-button {
			font-weight: 700;
			font-size: 16px;
			color: #2E2323;
			padding: 16px 0;
			margin-top: 50px;
			width: 100%;
			border: 1px solid #2E2323;
			border-radius: 5px;
		}
		.home-button {
			font-weight: 700;
			font-size: 16px;
			color: white;
			padding: 16px 0;
			width: 100%;
			margin-top: 20px;
			background-color: #2E2323;
			border-radius: 5px;
		}
	}
}
@media only screen and (max-width: 600px) {
	.alert-container {
		width: 90%;
		.title {
			font-size: 14px;
		}
	}
}
</style>
